import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// ClientSystemVariables Redux States
import {
  GET_CLIENT_SYSTEM_VARIABLE_VALUES,
  GET_CLIENT_SYSTEM_VARIABLE_VALUE,
  CREATE_CLIENT_SYSTEM_VARIABLE_VALUE,
  DELETE_CLIENT_SYSTEM_VARIABLE_VALUE,
  EDIT_CLIENT_SYSTEM_VARIABLE_VALUE,
} from "./actionTypes";
import {
  setClientSystemVariables,
  apiError,
  setClientSystemVariable,
  createClientSystemVariableSuccess,
  editClientSystemVariableSuccess,
  deleteClientSystemVariableSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getClientSystemVariables({
  payload: { idCompany, page, qnt, name },
}) {
  try {
    const response = yield call(
      axios.get,
      `/client-system-variable?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setClientSystemVariables(response.data.data, qnt, idCompany));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createClientSystemVariable({
  payload: { newClientSystemVariableValues, idCompany, idDepartment },
}) {
  try {
    let response = yield call(
      axios.post,
      `/client-system-variable`,
      newClientSystemVariableValues
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(createClientSystemVariableSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getClientSystemVariable({
  payload: { idClientSystemVariable, idCompany, isForm },
}) {
  try {
    let response = yield call(
      axios.get,
      `/client-system-variable?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idClientSystemVariable ? `&id=${idClientSystemVariable}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setClientSystemVariable(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editClientSystemVariable({
  payload: { idClientSystemVariable, newClientSystemVariableValues, idCompany },
}) {
  try {
    let response = yield call(
      axios.patch,
      `/client-system-variable?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idClientSystemVariable ? `&id=${idClientSystemVariable}` : "")
      }`,
      newClientSystemVariableValues
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editClientSystemVariableSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteClientSystemVariable({
  payload: { idClientSystemVariable, idCompany },
}) {
  try {
    let response = yield call(
      axios.delete,
      `/client-system-variable?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idClientSystemVariable ? `&id=${idClientSystemVariable}` : "")
      }`,
      {}
    );

    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteClientSystemVariableSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchClientSystemVariablesClient() {
  yield takeEvery(GET_CLIENT_SYSTEM_VARIABLE_VALUES, getClientSystemVariables);
}
export function* watchGetClientSystemVariable() {
  yield takeEvery(GET_CLIENT_SYSTEM_VARIABLE_VALUE, getClientSystemVariable);
}
export function* watchCreateClientSystemVariable() {
  yield takeEvery(
    CREATE_CLIENT_SYSTEM_VARIABLE_VALUE,
    createClientSystemVariable
  );
}
export function* watchEditClientSystemVariable() {
  yield takeEvery(EDIT_CLIENT_SYSTEM_VARIABLE_VALUE, editClientSystemVariable);
}
export function* watchDeleteClientSystemVariable() {
  yield takeEvery(
    DELETE_CLIENT_SYSTEM_VARIABLE_VALUE,
    deleteClientSystemVariable
  );
}
function* authSaga() {
  yield all([
    fork(watchClientSystemVariablesClient),
    fork(watchCreateClientSystemVariable),
    fork(watchGetClientSystemVariable),
    fork(watchEditClientSystemVariable),
    fork(watchDeleteClientSystemVariable),
  ]);
}

export default authSaga;
